module.exports = __webpack_public_path__ + "static/media/11.808f94c4.svg";